// @ts-strict-ignore
/**
 * @owner @Appboy/clip
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/webhooks_credit_consumption_detail_data" endpoint
 */
import { isWebhooksConsumptionResult } from "@dashboardApi/apis/webhooksConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { webhooksConsumption } from "./constants";
import type { WebhooksConsumptionParams, WebhooksConsumptionResult } from "./types";

export const getDataTableWebhooksConsumption = reactQueryTableFetcherAdapter(
  webhooksConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: WebhooksConsumptionParams
  ): Promise<WebhooksConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/webhooks_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
        }),
      },
      { signal }
    );
  },
  isWebhooksConsumptionResult
);
